export function preload<Props>(component: React.ComponentType<Props>) {
  if (isPreloadable(component)) {
    component.preload();
  }
}

function isPreloadable<Props>(
  component: React.ComponentType<Props>
): component is Preloadable<Props> {
  return "preload" in component && typeof component.preload === "function";
}

type Preloadable<Props> = React.ComponentType<Props> & {
  preload: () => void;
};
